import React, { Fragment } from 'react';
import Breadcrumb from '../layout/breadcrumb'
import {Container,Row,Col,Card,CardHeader,CardBody, cardFooter, Button} from 'reactstrap';

import Web3 from "web3";

const LoginMetamask = async () => {
    // Modern dapp browsers...
    if (window.ethereum) {
    const web3 = new Web3(window.ethereum);
    try {
        await window.ethereum.enable();
    } catch (error) {
        //////console.log(error)
    }
    }
    else if (window.web3) {
    const web3 = window.web3;
    ////console.log("Injected web3 detected.");
    }
    else {
    const provider = new Web3.providers.HttpProvider(
        "https://data-seed-prebsc-1-s1.binance.org:8545/"
    );
    const web3 = new Web3(provider);
    //console.log("No web3 instance injected, using Local web3.");
    }
}



const LoginError = (props) => {
    return (
         <Fragment>
         <Breadcrumb title="Please Log In"/>
          <Container fluid={true}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardHeader>
                    <h5>Please use MetaMask or any other Web3 Wallet to use CryptoMines</h5>
                    <span>CryptoMines is a decentralized play to earn game and therefore we need you to use any Web3 Wallet (MetaMask, OKEx Wallet, etc) to connect your browser to the Blockchain.</span>
                    <span>You should be in the correct network (BSC Mainnet), if you don’t know how to set your wallet, buy $ETERNAL or change to the correct network please follow our guide at <a target="_blank" href="https://docs.cryptomines.app/first-steps/1-starting-your-crypto-journey">https://docs.cryptomines.app/first-steps/1-starting-your-crypto-journey</a> </span>
                  </CardHeader>
                  {/* <CardBody>
                    <p><Button size="lg" onClick={() => LoginMetamask()}> 
                    <i className="icon-hand-point-right"> </i> 
                    Log In with MetaMask 
                    <i className="icon-hand-point-left"> </i> 
                    </Button></p>
                  </CardBody> */}
                </Card>
              </Col>

            </Row>
          </Container>   
         </Fragment> 
    );
}

export default LoginError;